<template>
  <el-dialog
    title="编辑可用区"
    :visible.sync="dialogVisible"
    width="600px"
    @close="resetForm"
    destroy-on-close
    :close-on-click-modal="false"
  >
    <!-- 表单 -->
    <div class="form-container">
      <el-form
        ref="editForm"
        :model="formData"
        :rules="formRules"
        label-width="140px"
        size="small"
      >
        <el-form-item label="可用区名称：" prop="name">
          <el-input v-model="formData.name" placeholder="请输入可用区名称"></el-input>
        </el-form-item>

        <el-form-item label="提供商：" prop="region_id">
          <el-select 
            v-model="formData.region_id" 
            placeholder="请选择提供商" 
            style="width: 100%;" 
            :loading="loading"
            @change="handleProviderChange"
          >
            <el-option 
              v-for="item in options" 
              :key="item.id" 
              :label="item.provider" 
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <!-- provider 显示为只读，避免手动修改导致不一致 -->
        <el-form-item label="提供商名称：" prop="provider" v-if="false">
          <!-- 隐藏但保留校验 -->
        </el-form-item>
        <el-form-item label="提供商名称：" v-else>
          <el-input v-model="formData.provider" readonly placeholder="自动填充" />
        </el-form-item>

        <el-form-item label="价格：" prop="price">
          <el-input v-model="formData.price" placeholder="请输入价格"></el-input>
        </el-form-item>

        <el-form-item label="是否纳管：" prop="ext_01">
          <el-select v-model="formData.ext_01" placeholder="请选择" style="width: 100%;" disabled>
            <el-option label="纳管" :value="0"></el-option>
            <el-option label="非纳管" :value="1"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="规模：" prop="scale">
          <el-input
            type="textarea" 
            :rows="3"
            v-model="formData.scale"
            placeholder="请输入规模"
            clearable
          />
        </el-form-item>

        <el-form-item label="GPU型号：" prop="gpu_model">
          <el-input v-model="formData.gpu_model" placeholder="请输入GPU型号"></el-input>
        </el-form-item>

        <el-form-item label="状态：" prop="status">
          <el-select v-model="formData.status" placeholder="请选择" style="width: 100%;">
            <el-option label="有效" :value="0" />
            <el-option label="关闭" :value="1" />
            <el-option label="待定" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="租赁规模：" prop="lease_scale">
          <el-select v-model="formData.lease_scale" placeholder="请选择" style="width: 100%;">
            <el-option label="任意" :value="0" />
            <el-option label="整租" :value="1" />
            <el-option label="散租" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="租赁形式：" prop="lease_type">
          <el-select v-model="formData.lease_type" placeholder="请选择" style="width: 100%;">
            <el-option label="任意" :value="0" />
            <el-option label="开口" :value="1" />
            <el-option label="闭口" :value="2" />
          </el-select>
        </el-form-item>

        <el-form-item label="设备规格：" prop="device_specification">
          <el-input v-model="formData.device_specification" placeholder="请输入设备规格"></el-input>
        </el-form-item>

        <el-form-item label="存储：" prop="storage">
          <el-input v-model="formData.storage" placeholder="请输入存储"></el-input>
        </el-form-item>

        <el-form-item label="存储网络：" prop="storage_network">
          <el-input v-model="formData.storage_network" placeholder="请输入存储网络"></el-input>
        </el-form-item>

        <el-form-item label="计算网络：" prop="compute_network">
          <el-input v-model="formData.compute_network" placeholder="请输入计算网络"></el-input>
        </el-form-item>

        <el-form-item label="出口规格：" prop="internet_spec">
          <el-input v-model="formData.internet_spec" placeholder="请输入出口规格"></el-input>
        </el-form-item>

        <el-form-item label="开始时间：" prop="start_time">
          <el-date-picker
            v-model="formData.start_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择开始时间"
            style="width: 100%;"
          />
        </el-form-item>

        <el-form-item label="结束时间：" prop="end_time">
          <el-date-picker
            v-model="formData.end_time"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择结束时间"
            style="width: 100%;"
          />
        </el-form-item>
        <el-form-item label="备注：" prop="remark">
          <el-input
            v-model="formData.remark"
            type="textarea"
            :rows="3"
            placeholder="请输入备注"
          />
        </el-form-item>
      </el-form>
    </div>

    <!-- 按钮 -->
    <div slot="footer">
      <el-button size="small" @click="dialogVisible = false">取消</el-button>
      <el-button size="small" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'EditProvider',

  data() {
    return {
      dialogVisible: false,
      providerId: '', // 存储要编辑的可用区记录 ID
      loading: true,
      options: [], // 提供商列表 { id, provider }
      // 表单数据
      formData: {
        name: '',
        region_id: '', // 用于绑定 select 的值
        provider: '', // 必填字段，由 region_id 自动填充
        gpu_model: '',
        device_specification: '',
        storage: '',
        storage_network: '',
        compute_network: '',
        internet_spec: '',
        price: '',
        scale: '',
        lease_scale: 0,
        lease_type: 0,
        status: 0,
        ext_01: 0,
        start_time: '',
        end_time: '',
        remark: ''
      },
      formRules: {
        name: [{ required: true, message: '请输入可用区名称', trigger: 'blur' }],
        region_id: [{ required: true, message: '请选择提供商', trigger: 'change' }],
        price: [{ required: true, message: '请输入价格', trigger: 'blur' }],
        provider: [{ required: true, message: '请选择提供商', trigger: 'change' }], // 确保必填
        start_time: [
          {
            validator: (rule, value, callback) => {
              callback(); // 非必填
            },
            trigger: 'change'
          }
        ],
        end_time: [
          {
            validator: (rule, value, callback) => {
              const startTime = this.formData.start_time;
              const endTime = value;
              if (!startTime || !endTime) return callback();
              const start = new Date(startTime);
              const end = new Date(endTime);
              if (end <= start) {
                callback(new Error('结束时间必须大于开始时间'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
      }
    };
  },

  methods: {
    async openDialog(row) {
      if (!row || !row.id) {
        this.$message.error('无效的数据，缺少id');
        return;
      }

      // 先加载提供商列表
      await this.fetchProviders();

      // 保存当前可用区 ID
      this.providerId = row.id;

      // 初始化表单数据
      this.formData = {
        name: row.name || '',
        region_id: row.region_id || '',
        provider: row.provider || '', // 初始值
        gpu_model: row.gpu_model || '',
        device_specification: row.device_specification || '',
        storage: row.storage || '',
        storage_network: row.storage_network || '',
        compute_network: row.compute_network || '',
        internet_spec: row.internet_spec || '',
        price: row.price || '',
        scale: row.scale || '',
        lease_scale: row.lease_scale == null ? 0 : row.lease_scale,
        lease_type: row.lease_type == null ? 0 : row.lease_type,
        status: row.status == null ? 0 : row.status,
        ext_01: row.ext_01 == null ? 0 : Number(row.ext_01),
        start_time: row.start_time || '',
        end_time: row.end_time || '',
        remark: row.remark || ''
      };

      // 🔁 校准：确保 provider 与 region_id 一致
      this.$nextTick(() => {
        const selected = this.options.find(item => item.id === this.formData.region_id);
        if (selected) {
          this.formData.provider = selected.provider;
        } else if (this.formData.region_id) {
          this.$message.warning('未找到对应的提供商，请重新选择');
        }
        this.$refs.editForm.clearValidate();
      });

      this.dialogVisible = true;
    },

    // ✅ 当选择 region_id 时，自动更新 provider
    handleProviderChange(regionId) {
      const selected = this.options.find(item => item.id === regionId);
      if (selected) {
        this.formData.provider = selected.provider;
      }
    },

    // ✅ 加载提供商列表
    fetchProviders() {
      this.loading = true;
      return this.$axios.get('/api-30216/api/regions')
        .then(res => {
          if (res.code === 200 && Array.isArray(res.data)) {
            this.options = res.data.map(item => ({
              id: item.id,
              provider: item.provider || '未知提供商'
            }));
          } else {
            this.$message.error(res.message || '加载提供商失败');
            this.options = [];
          }
        })
        .catch(err => {
          this.$message.error('请求失败，请检查网络');
          console.error(err);
          this.options = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },

    resetForm() {
      if (this.$refs.editForm) {
        this.$refs.editForm.resetFields();
      }
      this.providerId = '';
    },

    handleSubmit() {
      this.$refs.editForm.validate(async (valid) => {
        if (!valid) return;

        // ✅ 提交前再次校验一致性（可选）
        const selected = this.options.find(item => item.id === this.formData.region_id);
        if (selected && selected.provider !== this.formData.provider) {
          this.$message.error('提供商名称与选择的 region_id 不匹配，请重新选择');
          return;
        }

        try {
          const res = await this.$axios.put(`/api-30216/api/zones/${this.providerId}`, this.formData);
          const responseData = res.data || res;
          if (responseData.code === 200) {
            this.$message.success(responseData.message || '编辑成功');
            this.dialogVisible = false;
            this.$emit('success');
          } else {
            this.$message.error(responseData.message || '更新失败');
          }
        } catch (err) {
          let errorMessage = '请求失败';
          if (err && err.response && err.response.data && err.response.data.message) {
            errorMessage = err.response.data.message;
          } else if (err && err.message) {
            errorMessage = err.message;
          } else {
            errorMessage = '请求失败';
          }
          this.$message.error(errorMessage);
          console.error('请求错误详情:', err);
        }
      });
    }
  }
};
</script>